import { NextSeo } from 'next-seo';

import { useTranslation } from '@hooks';
import {
    AgreementModalWrapper,
    StaticPageContainer,
    StaticPageWrapper,
} from '@components/styles/StaticPagesStyles';
import {
    ContractPageLayout,
    KVKKMenu,
    StaticPagesTextContainer,
} from '@components/contracts';
import { BackButton } from '@components/ui';
import { capitalizeSentences } from '@utils';
import { Caption, Subtitle3, Text3 } from '@components/styles/Typography';
import styled from 'styled-components';

const PrivacyPolicy = () => {
    const { t, locale } = useTranslation();
    return (
        <div>
            <NextSeo
                title={`Fervente | ${capitalizeSentences(
                    t('customerClarifitacion'),
                )}`}
                description={t('privacyPolicyMetaDesc')}
            />
            <AgreementModalWrapper>
                {locale === 'tr' ? (
                    <ContractPageLayout
                        title={t('customerClarifitacion').toUpperCase()}
                    >
                        <KVKKMenu activeMenu="privacy-policy" />
                        <StaticPageWrapper marginTop="0" marginTopMobile="0">
                            <BackButton
                                title={t('customerClarifitacion').toUpperCase()}
                                tabletHide
                            />
                            <StaticPageContainer>
                                <StaticPagesTextContainer title="WEBSİTESİ ZİYARETÇİ VE E-TİCARET MÜŞTERİLERİMİZİN KİŞİSEL VERİLERİNİN İŞLENMESİNE İLİŞKİN AYDINLATMA METNİ">
                                    <Text3>
                                        Değerli Müşterimiz; <br />
                                        <br />
                                        Kişisel verileriniz 6698 sayılıKişisel
                                        Verilerin Korunması Kanunu uyarınca veri
                                        sorumlusu olarak Keikei Tekstil Ve Giyim
                                        Sanayi Ticaret Anonim Şirketi
                                        (‘’[KEİKEİ]’’ veya “Şirket”) tarafından
                                        aşağıda açıklanan şekilde
                                        işlenebilecektir.
                                    </Text3>
                                    <MarginWrapper>
                                        <Subtitle3>
                                            Kişisel Verileri Toplama Yöntemleri
                                            ve Hukuki Sebepleri:
                                        </Subtitle3>
                                    </MarginWrapper>
                                    <Text3>
                                        Şirketimiz,kişisel verileri, Site
                                        üzerinden yaptığınız alışverişlerin veya
                                        üyelik işlemlerine ilişkin yahut üye
                                        olmadan alışveriş için paylaştığınız
                                        bilgilerin sistemlerimize kaydedilmesi
                                        suretiyle Sabit/mobil internet ve
                                        iletişim cihazlarınızın ve/veya mobil
                                        uygulamaların muhtelif ortamlarda ve
                                        yerde kullanımlarından oluşan/edinilen
                                        verilerin sistemlerimize kaydedilmesi
                                        suretiyle, Site üzerindeki her türlü
                                        üyelik, alışveriş, tahsilat, teslimat ve
                                        bunlara yönelik işlem,anket doldurma,
                                        kayıt ve davranışsal işlemlerin
                                        sistemlerimize kaydedilmesi ve iade
                                        süreçlerine ilişkin kayıtların ilgili
                                        evrakların kaydedilmesi vasıtaları
                                        kapsamında doğrudan müşterinin
                                        kendisinin verdiği bilgilerden ve
                                        tahsilat araçları vasıtasıyla öğrenilen
                                        verilerden elde etmektedir. Kişisel
                                        verileriniz; <br />
                                        <br /> Satın aldığınız ürünlerin
                                        gönderimi için teslimat adresinizin
                                        talep edilmesi, doğru gönderim için isim
                                        soy isim bilgilerinizin alınması, üyelik
                                        sözleşmesi kapsamında ID ve şifre
                                        bilgilerinizin alınması gibi işlemler
                                        yönünden sözleşmenin kurulması ve ifası
                                        için veri işlemenin gerekli olması,{' '}
                                        <br />
                                        <br /> Vergi Usul Kanunu ve diğer
                                        mevzuat kapsamında satış yapılan
                                        ürünlerin faturalarının tanzimi ile
                                        bildirilmesi, Tüketicinin Korunması
                                        Hakkında Kanun ve yan mevzuat kapsamında
                                        cayma ve diğer haklarınızı etkin
                                        kullanabilmeniz için iade yapılacak
                                        banka hesap bilgileriniz kanunlarda
                                        açıkça öngörülme ve hukuki yükümlülüğün
                                        yerine getirilmesi, <br />
                                        <br /> Site güvenliği için toplanan
                                        çerezler gibi veriler veri sorumlusunun
                                        meşru menfaati, tarafınızın erişimin
                                        sağlanabilmesi, <br />
                                        <br /> Reklam ve diğer opsiyonel
                                        çerezlerin sizlere daha iyi bir deneyim
                                        sunulması ve pazarlama faaliyetleri
                                        yürütülmesi için bu ve benzeri işlemler
                                        ise açık rıza hukuki sebeplerine dayalı
                                        olarak işlemektedir.
                                    </Text3>
                                    <MarginWrapper>
                                        <Subtitle3>
                                            Farklı Aşamalarda İşlenebilecek Veri
                                            Kategorileri ve Veri Türleri
                                        </Subtitle3>
                                    </MarginWrapper>
                                    <Text3>
                                        <Caption>Kimlik : </Caption> Ad
                                        –Soyad(**)(*), Firma Adı (İsteğe Bağlı)
                                        (*), Cinsiyet(****), Doğum Tarihi(****),
                                    </Text3>{' '}
                                    <Text3>
                                        <Caption>İletişim : </Caption> Telefon
                                        numarası(*), Şehir(*), İlçe/Semt(*),
                                        Sokak Adresi(*), Posta Kodu(*), E posta
                                        adresi(**)(*), Ülke (*), Lokasyon (****)
                                    </Text3>{' '}
                                    <Text3>
                                        <Caption>Müşteri İşlem : </Caption>{' '}
                                        Kullanıcı adı(**), Alışveriş geçmişi
                                        bilgileri, Satın alınan ürün/hizmet
                                        bilgileri, Sipariş bilgisi, Üyelik ID-
                                        Şifre Bilgisi(**), Teslimat adresi,
                                        Siteyi kullanım bilgileriniz, Çerez
                                        kayıtlarınız, Sipariş Notu(*)
                                    </Text3>{' '}
                                    <Text3>
                                        <Caption>Finans : </Caption> Banka/kredi
                                        kartı bilgileri(***), Fatura adresi ve
                                        diğer fatura bilgileri, (***)Banka hesap
                                        bilgileri
                                    </Text3>
                                    <Text3>
                                        *İlgili kişisel verileriniz internet
                                        sitemizden alışveriş yapmanız durumunda
                                        ödeme aşamasında tarafınızca
                                        doldurulması neticesinde elde
                                        edilmektedir.
                                    </Text3>
                                    <Text3>
                                        ** İlgili kişisel verileriniz siteye üye
                                        olmanız halinde işlenmektedir.
                                    </Text3>
                                    <Text3>
                                        *** İade talepleriniz doğrultusunda
                                        bizlerle paylaştığınız takdirde
                                        işlenmekte satın alma aşamasında kredi /
                                        banka kartı bilgileriniz şirketimizce
                                        kaydedilmemekte, işlenmemektedir.
                                    </Text3>
                                    <Text3>
                                        **** Kişisel Bilgilerim sayfasından
                                        sonradan isteğe bağlı olarak eklemeniz
                                        halinde işlenmektedir.
                                    </Text3>
                                    <Text3>
                                        Tabloda belirtilen kişisel veriler
                                        olağan faaliyetler kapsamında
                                        işlenebilecek kişisel verilerinizi
                                        belirtmekte olup istisnai işlemler
                                        kapsamında yine bu Aydınlatma Metni
                                        bağlamında kişisel verileriniz
                                        işlenebilir.
                                    </Text3>
                                    <MarginWrapper>
                                        <Subtitle3>
                                            Kişisel Verileri İşleme Amaçları
                                        </Subtitle3>
                                    </MarginWrapper>
                                    <Text3>
                                        Kişisel verileriniz, üyelik
                                        sözleşmesinin kurulması ve ifası,
                                        müşteri kayıtlarının oluşturulması ve
                                        takibi, satış sözleşmesinin kurulması ve
                                        ifa edilebilmesi, fatura tanzimi ve
                                        iletilmesi, satış ve satış sonrası
                                        hizmetlerde müşteri menfaatinin
                                        korunması, özellikle iade ile ilk ve
                                        yeniden ürünlerin kargo vasıtasıyla
                                        gönderilmesi, bedel iadesi dahil ürün
                                        iade sürecinin yürütülmesi, müşteriye
                                        sonraki olası işlemlerinde kolaylık
                                        sağlanması, talep ve şikayetlerin
                                        takibi, iş sürekliliği ve faaliyetin
                                        devamlılığının sağlanması, pazarlama ve
                                        analiz çalışmalarının yürütülmesi,
                                        müşteri memnuniyetine yönelik
                                        aktivitelerin yürütülmesi, Ticari
                                        İletişim ve Ticari Elektronik İletiler
                                        Hakkında Yönetmelik kapsamında izin
                                        veren müşterilerimize kampanya – indirim
                                        vb. durumlarda müşterinin
                                        yararlanabilmesi için haberdar edilmesi,
                                        bilgi güvenliği süreçlerinin
                                        planlanması, denetim ve icrası, yetkili
                                        kişi, kurum ve kuruluşlara bilgi
                                        verilmesi, bilgi teknolojileri alt
                                        yapısının oluşturulması ve yönetilmesi
                                        amaçlarıyla işlenmektedir.
                                    </Text3>
                                    <MarginWrapper>
                                        <Subtitle3>
                                            Kişisel Verilerin Aktarılması
                                        </Subtitle3>
                                    </MarginWrapper>
                                    <Text3>
                                        Kişisel verileriniz, “bilme gereği” ve
                                        “kullanma gereği” ilkelerine uygun
                                        olarak ve gerekli veri minimizasyonunu
                                        sağlanarak; yukarıda belirtilen
                                        amaçların gerçekleştirilmesi
                                        doğrultusunda ve bu amaçların yerine
                                        getirilmesi ile sınırlı olarak;
                                        hissedarlarımızla, iş ortaklarımızla,
                                        iştiraklerimiz ve bağlı şirketlerimiz ve
                                        hissedarlarıyla, Şirketimizin
                                        yurtiçindeki hizmet sağlayıcılarıyla,
                                        pazarlama/reklam/analiz hizmeti
                                        sağlayıcıları, veri tabanı ve sunucu
                                        hizmeti sağlayıcıları, site
                                        kullanımlarını izleme hizmeti
                                        sağlayanlar, e-posta sunucu hizmeti
                                        sağlayıcıları, e-fatura ve e-arşiv
                                        fatura hizmeti sağlayıcıları, elektronik
                                        ileti aracı hizmet sağlayıcıları, kargo
                                        ve kurye firmaları, banka ve elektronik
                                        ödeme kuruluşları, hukuki ve mali
                                        danışmanlık hizmeti verenler bağımsız
                                        denetim hizmeti sağlayıcıları, arşivleme
                                        hizmeti verenler, bilişim altyapımızı
                                        sağlayan, işleten veya hizmet sunan iş
                                        ortaklarımızla ve hizmet
                                        sağlayıcılarımızla, özel iş
                                        ortaklığımızın olduğu kanunen yetkili
                                        kamu kurumları ve özel kişi veya
                                        kuruluşlar ile üçüncü kişilere, <br />
                                        <br /> Ayrıca; <br />
                                        Denetleme ve durum tespit faaliyetleri
                                        için uzmanlar, hukuk büroları ve
                                        denetleme firmaları ile düzenleyici ve
                                        sözleşmesel yükümlülüklerin yerine
                                        getirilmesi için kamu kurumları, sigorta
                                        şirketleri, sosyal yardım destek
                                        fonları, iş danışmanlarıyla
                                        <br />
                                        <br /> Yetkili idari ve denetleme
                                        kurullarıyla ve/veya diğer yetkili
                                        denetleyici kurum ve kuruluşlarla,
                                        <br />
                                        <br /> Hukuki uyuşmazlıkların
                                        giderilmesi veya ilgili mevzuatı gereği
                                        talep halinde idari makamlar, adli
                                        makamlar veya ilgili kolluk
                                        kuvvetleriyle işbu aydınlatma metninde
                                        belirtilen amaçlarla sınırlı olarak
                                        aktarılabilecek, yurt içinde veya yurt
                                        dışında işlenebilecektir.
                                    </Text3>
                                    <MarginWrapper>
                                        <Subtitle3>
                                            İlgili Kişinin Hakları
                                        </Subtitle3>
                                    </MarginWrapper>
                                    <Text3>
                                        Kişisel verisi işlenen kişi olarak,
                                        Kanun’un ilgili kişinin haklarını
                                        düzenleyen 11. maddesi kapsamındaki
                                        haklarınızı (kişisel veri işlemeyi
                                        öğrenme, işlemeyle ilgili bilgi talep
                                        etme, işlemenin amaca uygunluğunu
                                        öğrenme, aktarım yapılan kişileri bilme,
                                        eksik veya yanlış işlemelerin
                                        düzeltilmesini isteme, silme veya yok
                                        edilmesini isteme, otomatik tüm
                                        işlemlerin üçüncü kişilere
                                        bildirilmesini isteme, analize itiraz
                                        etme, zararın giderilmesini talep etme)
                                        Veri Sorumlusuna Başvuru Usul ve
                                        Esasları Hakkında Tebliğe göre kullanmak
                                        için ile kvkk@keikei.com.tr iletişime
                                        geçebilir veya www.keikei.com adresinde
                                        yer alan “Başvuru Formu”nu doldurup;
                                        <br />
                                        <br /> Dolapdere Cd. Küçükbayır Sk.
                                        119/A Şişli / İstanbul adresine bizzat
                                        getirebilir,
                                        <br />
                                        Belirtilen adrese, ıslak imzalı olarak
                                        noter kanalıyla gönderebilir,
                                        <br />
                                        keikei@hs01.kep.tr adresine güvenli
                                        elektronik ya da mobil imzalı olarak,
                                        kayıtlı elektronik posta adresi veya
                                        sistemimizde kayıtlı elektronik e-posta
                                        adresiniz aracılığıyla iletebilirsiniz.
                                        <br />
                                        <br /> Başvuruda ad, soyad, Türkiye
                                        Cumhuriyeti vatandaşları için T.C.
                                        kimlik numarası, yabancılar için uyruğu,
                                        pasaport numarası veya varsa kimlik
                                        numarası, tebligata esas yerleşim yeri
                                        veya iş yeri adresi, varsa bildirime
                                        esas elektronik posta adresi, telefon ve
                                        faks numarası ve talep konusu yer
                                        almalıdır.
                                        <br />
                                        Başvurunuza yazılı olarak cevap
                                        verilecekse, on sayfaya kadar ücret
                                        alınmaz. On sayfanın üzerindeki her
                                        sayfa için 1 Türk Lirası işlem ücreti
                                        alınabilir. Başvuruya cevabın CD, flash
                                        bellek gibi bir kayıt ortamında
                                        verilmesi halinde Şirketimiz, kayıt
                                        ortamının maliyetini tarafınızdan talep
                                        edilebilecektir.
                                    </Text3>
                                    {/*  <Text3>
                                    <Subtitle3>
                                        {t("privacyPolicyTitle6")} :
                                    </Subtitle3>
                                    {t("privacyPolicyText12")}
                                </Text3>
                                <Subtitle3>
                                    {t("privacyPolicyTitle7")}
                                </Subtitle3>
                                <Text3>{t("privacyPolicyText6")}</Text3>
                                <Subtitle3></Subtitle3>

                                <Text3>{t("privacyPolicyText10")}</Text3>
                                <Subtitle3>
                                    {t("privacyPolicyTitle4")}
                                </Subtitle3>
                                <Text3>{t("privacyPolicyText4")}</Text3>
                                <Text3>{t("privacyPolicyText5")}</Text3>
                                <Text3>{t("privacyPolicyText9")}</Text3>
                                <Text3>{t("privacyPolicyText7")}</Text3>
                                <Text3>
                                    <Text3>{t("privacyPolicyText11")}</Text3>
                                </Text3>
                                <Subtitle3>{t("privacyPolicyTitle5")}</Subtitle3>
                                <Text3>
                                    <Text3>{t("privacyPolicyText12")}</Text3>
                                </Text3>
                                <Subtitle3>
                                    {t("privacyPolicyTitle6")}
                                </Subtitle3>
                                <table
                                    border="1"
                                    width="100%"
                                    cellSpacing="0"
                                    cellPadding="0"
                                >
                                    <tbody>
                                        <tr>
                                            <td width="179" valign="top">
                                                <Text3>
                                                    <strong>
                                                        {t(
                                                            "privacyPolicyText13",
                                                        )}
                                                    </strong>
                                                </Text3>
                                            </td>
                                            <td width="109" valign="toText">
                                                <Text3>
                                                    <strong>
                                                        {t(
                                                            "privacyPolicyText14",
                                                        )}
                                                    </strong>
                                                </Text3>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td width="179" valign="toText">
                                                <Text3>
                                                    {t("privacyPolicyText15")}
                                                </Text3>
                                                <Text3>
                                                    {t("privacyPolicyText16")}
                                                </Text3>
                                                <Text3>
                                                    {t("privacyPolicyText17")}
                                                </Text3>
                                                <Text3>
                                                    {t("privacyPolicyText18")}
                                                </Text3>
                                                <Text3>
                                                    {t("privacyPolicyText19")}
                                                </Text3>
                                                <Text3>
                                                    {t("privacyPolicyText20")}
                                                </Text3>
                                                <Text3>
                                                    {t("privacyPolicyText21")}
                                                </Text3>
                                                <Text3>
                                                    {t("privacyPolicyText22")}
                                                </Text3>
                                                <Text3>
                                                    {t("privacyPolicyText23")}
                                                </Text3>
                                            </td>
                                            <td width="109" valign="toText">
                                                <Text3>
                                                    {t("privacyPolicyText24")}
                                                </Text3>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td width="179" valign="toText">
                                                <Text3>
                                                    {t("privacyPolicyText25")}
                                                </Text3>
                                                <Text3>
                                                    {t("privacyPolicyText26")}
                                                </Text3>
                                                <Text3>
                                                    {t("privacyPolicyText27")}
                                                </Text3>
                                            </td>
                                            <td width="109" valign="toText">
                                                <Text3>
                                                    {t("privacyPolicyText28")}
                                                </Text3>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td width="179" valign="toText">
                                                <Text3>
                                                    {t("privacyPolicyText29")}
                                                </Text3>
                                            </td>
                                            <td width="109" valign="toText">
                                                <Text3>
                                                    {t("privacyPolicyText30")}
                                                </Text3>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                                <Text3>{t("privacyPolicyText31")}</Text3>
                                <Subtitle3>
                                    {t("privacyPolicyTitle7")}
                                </Subtitle3>
                                <Text3>{t("privacyPolicyText32")}</Text3>
                                <Subtitle3>
                                    {t("privacyPolicyTitle8")}
                                </Subtitle3>
                                <Text3>{t("privacyPolicyText33")}</Text3>
                                <Text3>{t("privacyPolicyText34")}</Text3>
                                <Text3>{t("privacyPolicyText35")}</Text3>
                                <Text3>{t("privacyPolicyText36")}</Text3>
                                <Text3>{t("privacyPolicyText37")}</Text3>
                                <Text3>{t("privacyPolicyText38")}</Text3>
                                <Text3>{t("privacyPolicyText39")}</Text3>
                                <Subtitle3>
                                    {t("privacyPolicyTitle9")}
                                </Subtitle3>
                                <Text3>{t("privacyPolicyText40")}</Text3>
                                <Text3>{t("privacyPolicyText41")}</Text3>
                                <Text3>{t("privacyPolicyText42")}</Text3>
                                <Text3>{t("privacyPolicyText43")}</Text3>
                                <Text3>{t("privacyPolicyText44")}</Text3>
                                <Text3>{t("privacyPolicyText45")}</Text3>
                                <Text3>{t("privacyPolicyText46")}</Text3>
                                <Text3>{t("privacyPolicyText47")}</Text3>
                                <Text3>{t("privacyPolicyText48")}</Text3>
                                <Text3>{t("privacyPolicyText49")}</Text3>
                                <Text3>{t("privacyPolicyText50")}</Text3>
                                <Text3>{t("privacyPolicyText51")}</Text3>
                                <Text3>{t("privacyPolicyText52")}</Text3>
                                <PrivacyPolicyLink href="www.keikei.com/privacypolicy/KeiKei-Veri-Sahipleri-Erisim-Talep-Formu-ADMD-240120.docx">
                                    {t("privacyPolicyText53")}
                                </PrivacyPolicyLink>
                                <Text3>{t("privacyPolicyText54")}</Text3> */}
                                </StaticPagesTextContainer>
                            </StaticPageContainer>
                        </StaticPageWrapper>
                    </ContractPageLayout>
                ) : (
                    <ContractPageLayout
                        title={t('customerClarifitacion').toUpperCase()}
                    >
                        <KVKKMenu activeMenu="privacy-policy" />
                        <StaticPageWrapper marginTop="0" marginTopMobile="0">
                            <BackButton title={t('KVKK')} tabletHide />
                            <StaticPageContainer>
                                <StaticPagesTextContainer title="CLARIFICATION TEXT ON THE PROCESSING OF PERSONAL DATA OF OUR WEBSITE VISITORS AND E-COMMERCE CUSTOMERS">
                                    <Text3>
                                        Dear customer; <br />
                                        <br />
                                        Your personal data may be processed as
                                        described below by Keikei Textile And
                                        Clothing Industry Trade Joint Stock
                                        Company (“KEİKEİ” or “Company”)as the
                                        data controller in accordance with the
                                        Law on Protection of Personal Data No.
                                        6698.
                                    </Text3>
                                    <MarginWrapper>
                                        <Subtitle3>
                                            Personal Data Collection Methods and
                                            Legal Reasons:
                                        </Subtitle3>
                                    </MarginWrapper>
                                    <Text3>
                                        Our company obtains personal data from
                                        your purchases on the site or By saving
                                        the information you share regarding
                                        membership transactions or for shopping
                                        without being a member, in our systems,
                                        By recording data consisting of/obtained
                                        from the use of your fixed/mobile
                                        internet and communication devices
                                        and/or mobile applications in various
                                        environments and places, on our systems,
                                        which are all kinds of membership,
                                        shopping, collection, delivery and
                                        transactions on the site, filling out
                                        surveys, recording the registration and
                                        behavioral transactions in our systems,
                                        and recording the relevant documents
                                        regarding the return processes, directly
                                        from the information provided by the
                                        customer and from the data learned
                                        through collection tools. Your personal
                                        data is processed due to;
                                        <br />
                                        <br />
                                        Data processing is required for the
                                        establishment and performance of the
                                        contract in terms of transactions such
                                        as requesting your delivery address for
                                        the shipment of the products you have
                                        purchased, obtaining your name and
                                        surname information for correct
                                        shipping, and obtaining your ID and
                                        password information within the scope of
                                        the membership agreement,
                                        <br />
                                        <br />
                                        Issuing the invoices of the products
                                        sold within the scope of the Tax
                                        Procedure Law and other legislation,
                                        Your bank account information to be
                                        refunded so that you can use your
                                        withdrawal and other rights effectively
                                        within the scope of the Consumer
                                        Protection Law and side legislation,
                                        clearly stipulated in the law and
                                        fulfilling the legal obligation
                                        <br />
                                        <br />
                                        Data such as cookies collected for site
                                        security are for the legitimate interest
                                        of the data controller, for you to
                                        provide access,
                                        <br />
                                        <br />
                                        These and similar transactions are
                                        processed based on explicit consent
                                        legal reasons, in order to provide you
                                        with a better experience and to carry
                                        out marketing activities by advertising
                                        and other optional cookies.
                                    </Text3>
                                    <MarginWrapper>
                                        <Subtitle3>
                                            Data Categories and Data Types That
                                            Can Be Processed at Different Stages
                                        </Subtitle3>
                                    </MarginWrapper>
                                    <Text3>
                                        <Caption>Identification : </Caption>
                                        Name-Surname(**), name of company(on
                                        basis of demand)(*), Gender(****), date
                                        of birth(****)
                                    </Text3>{' '}
                                    <Text3>
                                        <Caption>Communication : </Caption>{' '}
                                        Phone Number(*), City(*),
                                        Town/District(*), Street Address(*),Post
                                        code(*) E-mail address(**)(*),Country(*)
                                        Location(*)
                                    </Text3>{' '}
                                    <Text3>
                                        <Caption>
                                            Customer Transaction :{' '}
                                        </Caption>
                                        User Name(**), purchase history
                                        informations, purchased good/servise
                                        informations, order informations,
                                        Membership ID password informations(**),
                                        delivery address, website using
                                        informations, cookie records, order
                                        note(*)
                                    </Text3>{' '}
                                    <Text3>
                                        <Caption>Finance : </Caption> Bank/Debit
                                        card informations(***), invoice address
                                        and other invoice informations(***),
                                        bank account informations
                                    </Text3>
                                    <Text3>
                                        Your relevant personal data is obtained
                                        as a result of filling in by you at the
                                        payment stage, in case you shop on our
                                        website.
                                    </Text3>
                                    <Text3>
                                        ** Your relevant personal data is
                                        obtained as a result of being member.
                                    </Text3>
                                    <Text3>
                                        *** Your credit / debit card information
                                        is processed If you share it with us in
                                        line with your return requests, it is
                                        not processed or recorded by our company
                                        during the purchasing phase.
                                    </Text3>
                                    <Text3>
                                        **** It is processed if you optionally
                                        add it later from the My Personal
                                        Information page.
                                    </Text3>
                                    <Text3>
                                        The personal data specified in the table
                                        indicate your personal data that may be
                                        processed within the scope of ordinary
                                        activities, and within the scope of
                                        exceptional transactions, your personal
                                        data may be processed in the context of
                                        this Clarification Text.
                                    </Text3>
                                    <MarginWrapper>
                                        <Subtitle3>
                                            Purposes of Processing Personal Data{' '}
                                        </Subtitle3>
                                    </MarginWrapper>
                                    <Text3>
                                        Your personel data is processed for
                                        making membership aggreement, creation
                                        and follow-up of customer records,
                                        establishment and execution of the sales
                                        agreement, execution and preparing sales
                                        contract and , preparing and transfer of
                                        invoice, Protection of customer
                                        interests in sales and after- sales
                                        services, especially with the return,
                                        sending the first and re-sending
                                        products by cargo, carrying out the
                                        product return process, including the
                                        refund,follow-up of requests and
                                        complaints, Ensuring business continuity
                                        and continuity of activity, conducting
                                        marketing and analysis studies, carrying
                                        out activities for customer hapiness,
                                        Within the scope of the Regulation on
                                        Commercial Communication and Commercial
                                        Electronic Messages, our customers who
                                        give permission, offer campaigns,
                                        discounts, etc. informing the customer
                                        so that they can benefit from, planning,
                                        auditing and execution of information
                                        security processes, Providing
                                        information to authorized persons,
                                        institutions and organizations, Creation
                                        and management of information technology
                                        infrastructure
                                    </Text3>
                                    <MarginWrapper>
                                        <Subtitle3>
                                            Transfer of Personal Data
                                        </Subtitle3>
                                    </MarginWrapper>
                                    <Text3>
                                        Your personal data may be processed in
                                        accordance with the principles of “need
                                        to know” and “need to use” and by
                                        providing the necessary data
                                        minimization; with our shareholders,
                                        business partners, affiliates and
                                        subsidiaries and their shareholders, our
                                        companys domestic and international
                                        service providers,
                                        marketing/advertisement/analyise service
                                        providers, database and server service
                                        providers, , providers of site usage
                                        monitoring services,e-mail server
                                        service providers, e-invoice and
                                        e-archive invoice service providers,
                                        electronic message service providers,
                                        cargo and courier companies, banks and
                                        electronic payment institutions, legal
                                        and financial consultancy services,
                                        independent audit service providers,
                                        archiving services, our business
                                        partners and service providers that
                                        provide, operate or provide services to
                                        our IT infrastructure, legally
                                        authorized public institutions and
                                        private persons or organizations with
                                        which we have private business
                                        partnerships, and third parties,
                                        <br />
                                        <br />
                                        Besides;
                                        <br />
                                        Experts, law firms and audit firms for
                                        auditing and due diligence activities
                                        and public institutions for the
                                        fulfillment of regulatory and
                                        contractual obligations, insurance
                                        companies, , social assistance support
                                        funds, business advisors,
                                        <br />
                                        <br />
                                        With the authorized administrative and
                                        supervisory boards and/or other
                                        authorized supervisory institutions and
                                        organizations,
                                        <br />
                                        <br />
                                        In the country or abroad, which can be
                                        transferred to the administrative
                                        authorities, judicial authorities or
                                        relevant law enforcement authorities for
                                        the resolution of legal disputes or in
                                        accordance with the relevant
                                        legislation, limited to the purposes
                                        specified in this clarification text.
                                    </Text3>
                                    <MarginWrapper>
                                        <Subtitle3>
                                            Rights of Concerned Person
                                        </Subtitle3>
                                    </MarginWrapper>
                                    <Text3>
                                        As the person whose personal data is
                                        processed, to exercise Your rights under
                                        Article 11 of the Law, which regulates
                                        the rights of the person concerned in
                                        line with Communiqué on Application
                                        Procedures and Principles to Data
                                        Controller you can contact
                                        kvkk@keikei.com.tr or fill the
                                        “Application form” on the
                                        www.keikei.com;
                                        <br />
                                        <br />
                                        You may bring the form to Dolapdere
                                        Road, Küçükbayır St. 119/A
                                        Şişli/İstanbul by yourself,
                                        <br />
                                        <br />
                                        You may send to the specified address,
                                        with wet signature, through a notary
                                        public,
                                        <br />
                                        <br />
                                        You may send it to keikei@hs01.kep.tr
                                        with secure electronic or mobile
                                        signature, via your registered e-mail
                                        address or your e-mail address
                                        registered in our system.
                                        <br />
                                        <br />
                                        In the application there must be name,
                                        surname, T.C. identification number for
                                        Turhish citizens, nationality for
                                        foreigners, passport number or
                                        identification number, place of
                                        residence or business adress, e-mail
                                        address for notification, phone and fax
                                        number and subject of application.
                                        <br />
                                        <br />
                                        If your application will be answered in
                                        writing, up to ten pages will not be
                                        charged. A transaction fee of 1 Turkish
                                        Lira may be charged for each page if it
                                        is over ten pages. If the response to
                                        the application is given in a recording
                                        medium such as CD or flash memory, our
                                        Company may request the cost of the
                                        recording medium from you.
                                    </Text3>
                                </StaticPagesTextContainer>
                            </StaticPageContainer>
                        </StaticPageWrapper>
                    </ContractPageLayout>
                )}
            </AgreementModalWrapper>
        </div>
    );
};

const MarginWrapper = styled.div`
    margin: 10px 0;
`;
export default PrivacyPolicy;
